import type { SorterResult } from "antd/lib/table/interface";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "components";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import type { AllowedProductProfileList } from "src/app/features/AllowedProductProfile/types/AllowedProductProfileList";
import { displayStatusValue } from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";

export const AllowedProductsProfilesTable: FC<ResourceTableProps<AllowedProductProfileList>> = ({
    onStateChanged,
    onRowSelectionChange,
    datasource,
    resource,
}) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<AllowedProductProfileList>): ExtendedColumnsType<AllowedProductProfileList>[] => {
            return [
                {
                    title: t("allowedProductsProfiles.id"),
                    key: "id",
                    dataIndex: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("allowedProductsProfiles.name"),
                    dataIndex: "name",
                    key: "name",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "name" ? sortInfo.order : null,
                },
                {
                    title: t("allowedProductsProfiles.status"),
                    key: "status",
                    dataIndex: "status",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "status" ? sortInfo.order : null,
                    render: (value) => displayStatusValue(value),
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: AllowedProductProfileList) =>
        navigate(`${BASE_PATH}/${ResourceName.ALLOWED_PRODUCT_PROFILES}/${FORM_ACTION.EDIT}/${record.id}`);

    return (
        (datasource && (
            <GenericTable<AllowedProductProfileList>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                name="allowedProductProfile_table"
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: AllowedProductProfileList) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
                resource={resource}
            />
        )) ||
        null
    );
};
